import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface BreadcrumbItem {
  to?: string;
  label: string;
}

interface BreadcrumbKey {
  key: string;
  to?: string;
}

export function useBreadcrumb(namespace: string | string[], items: BreadcrumbKey[]): BreadcrumbItem[] {
  const { t } = useTranslation(namespace);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => items.map((item) => ({ to: item.to, label: t(item.key) })), [t]);
}
